import { useState, useEffect } from "react";
import { addInputsForm, updateInputsForm } from "../../lib/actions";
import DropDown from "../../components/GDropDownList/DropDown";
import { useNavigate } from "react-router-dom";
import { ThreeDot } from "react-loading-indicators";
import { useTranslation } from "react-i18next";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { FiUploadCloud } from "react-icons/fi";

export default function EditInputsUi({inputId, typeOfInputs, inputsData }) {

    const nav = useNavigate();
    const [typeId, setTypeId] = useState(null)
    const [check, setCheck] = useState(null);
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(null);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    useEffect(() => {
        setTypeId(inputsData.type);
        setCheck(inputsData.required);
        setImage(inputsData?.icon);
    }, [inputsData]);

    const handleChangeCheck = () => {
        setCheck(!check);
    };

    const onchange = (e) => {
        setTypeId(e);
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const formData = new FormData(e.target);
            formData.set("required", check === true ? 1 : 0);
        const result = await updateInputsForm(inputId, formData, navigate);
        setLoading(false);
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setImage(URL.createObjectURL(file));
        }
    };

    const handleDeleteImage = () => {
        setImage(null);
    };

    const navigate = (route) => {
        nav(route);
    };

    if (Object.keys(inputsData)?.length < 1 ){
        return <div className="flex justify-center items-center h-[25rem]"><ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" /></div> 
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1  md:grid-cols-2 sm:grid-cols-1 gap-3">
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "name in arabic" : "الاسم باللغة العربية "} </label>
                    <input
                        type="text"
                        defaultValue={inputsData?.label?.ar}
                        name="name_ar"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 rounded-lg text-white"
                        required
                        placeholder={currentLang === "en" ? "enter name in arabic" : "أدخل الاسم باللغة العربية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "name in english" : "الاسم باللغة الانجيليزية "}</label>
                    <input
                        type="text"
                        defaultValue={inputsData?.label?.en}
                        name="name_en"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter name in english" : " أدخل الاسم باللغة الانجليزية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "input type" : "نوع الحقل"}</label>
                    <DropDown defaultText={currentLang === "en" ? "choose input type" : "اختر نوع الحقل"} value={typeId} options={typeOfInputs} paramkey={"type"} onchange={onchange} />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "entry terms" : "شروط الادخال "} </label>
                    <input
                        type="text"
                        defaultValue={inputsData.regex}
                        name="regex"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        
                        placeholder={currentLang === "en" ? "enter entry terms" : "أدخل شروط الادخال"}
                    />
                </div>
                <div className="flex gap-4 sm:flex-row flex-col sm:justify-between items-start">
                    <div className="flex items-center gap-3">
                        <div
                            onClick={handleChangeCheck}
                            className={`relative w-14 h-6 rounded-full cursor-pointer transition
                            ${check ? (currentLang === 'ar' ? 'bg-secondary' : 'bg-secondary') : (currentLang === 'ar' ? 'bg-gray-400' : 'bg-gray-400')}`}
                        >
                            <span
                            className={`w-5 h-4 mt-1 bg-white rounded-full shadow-md block
                                transform transition
                                ${check ? (currentLang === 'ar' ? '-translate-x-1' : 'translate-x-7') : (currentLang === 'ar' ? '-translate-x-7' : 'translate-x-1')}`}
                            />
                        </div>
                        <label className="text-white">
                        {check
                            ? currentLang === "en"
                            ? "require"
                            : "حقل اجباري"
                            : currentLang === "en"
                            ? "optional"
                            : "حقل اختياري"
                        }
                        </label>
                    </div>
                </div>
            </div>

            <div className="mt-4">
                <label className="block text-white mb-6">{currentLang === "en" ? "photo" : "الصورة"}</label>
                <div className="flex justify-center items-center">
                    <div className="bg-thirdly sm:w-[50%] w-[100%] p-6 rounded-2xl border-2 border-dashed border-gray-200">
                            {/* <label className="block text-sm font-medium text-gray-700 mb-4">الصورة الرئيسية</label> */}
                        <div className="relative group">
                            <div className={`flex flex-col items-center justify-center  h-48 ${!image ? 'bg-furthly' : 'bg-transparent'} rounded-xl transition-all`}>
                                    {!image ? (
                                        <>
                                            <FiUploadCloud className="w-12 h-12 text-white mb-3 group-hover:text-secondary transition-colors" />
                                            <span className="text-sm text-white group-hover:text-secondary transition-colors">
                                               {currentLang === "en" ? "click to upload a photo" : " انقر لرفع الصورة"}
                                            </span>
                                        </>
                                    ) : (
                                        <div className="relative w-full h-full">
                                            <img src={image} alt="الصورة الملتقطة" className="w-full h-full object-contain rounded-xl" />
                                            <button type="button" className="absolute top-2 left-2 z-50 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors shadow-lg" onClick={handleDeleteImage}>
                                                <MdOutlineDeleteOutline className="w-5 h-5" />
                                            </button>
                                        </div>
                                    )}
                            </div>
                            <input type="file" name="image" accept="image/*" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" onChange={handleImageChange}  />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-center w-full mt-10 mb-2">
                <button
                    type="submit"
                    disabled={loading}
                    className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary"
                        }`}
                >
                    {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("button.save")
                    )}
                </button>
            </div>
        </form>
    );
};